export enum StateCustomDataConstants {
  SET_APPLICABLE_STATES = 'stateCustomData/SET_APPLICABLE_STATES',
  SET_STATE_CUSTOM_DISPLAY_DATA = 'stateCustomData/SET_STATE_CUSTOM_DISPLAY_DATA',
  SET_STATE_CUSTOM_ELEMENT_VALUE = 'stateCustomData/SET_STATE_CUSTOM_ELEMENT_VALUE',
  SET_STATE_CUSTOM_ELEMENT_PNNV_VALUE = 'stateCustomData/SET_STATE_CUSTOM_ELEMENT_PNNV_VALUE',
  SET_STATE_MULTI_INSTANCE_CUSTOM_ELEMENT_PNNV_VALUE = 'stateCustomData/SET_STATE_MULTI_INSTANCE_CUSTOM_ELEMENT_PNNV_VALUE',
  DELETE_CUSTOM_ELEMENT_GROUP = 'stateCustomData/DELETE_CUSTOM_ELEMENT_GROUP',
  DUPLICATE_GROUP = 'stateCustomData/DUPLICATE_GROUP',
  UPDATE_GROUPS_FROM_TIMELINE = 'stateCustomData/UPDATE_GROUPS_FROM_TIMELINE',
  DUPLICATE_CUSTOM_ELEMENT = 'stateCustomData/DUPLICATE_CUSTOM_ELEMENT',
  DELETE_CUSTOM_ELEMENT = 'stateCustomData/DELETE_CUSTOM_ELEMENT',
  SET_CUSTOM_DATA = 'stateCustomData/SET_CUSTOM_DATA',
  SET_DISPLAY_DATA = 'stateCustomData/SET_DISPLAY_DATA',
  SET_PNNV_TOGGLE = 'stateCustomData/SET_PNNV_TOGGLE',
  SAVE_CUSTOM_DATA = 'stateCustomData/SAVE_CUSTOM_DATA',
  RESET_NEMSIS_CUSTOM_DATA = 'stateCustomData/RESET_NEMSIS_CUSTOM_DATA',

  ADD_TIMELINE_GROUP = 'ADD',
  REORDER_TIMELINE_GROUP = 'REORDER',
  REMOVE_TIMELINE_GROUP = 'REMOVE',
  REMOVE_MEDICATION_GROUP = 'REMOVE_MEDICATION',
}
